module.exports = __webpack_public_path__ + "img/banner_dados_referentes_denúncias.3009afe6.png";